import MuiFormControl, { FormControlProps } from "@mui/material/FormControl";

const FormControl: React.FC<FormControlProps> = MuiFormControl;

export default FormControl;

export type { FormControlProps };
